export const LINK_STUDENTS_CSV_TEMPLATE = 'https://app.dev.kidvestors.co/assets/csv-templates/StudentsTemplate.csv';
export const LINK_TEACHER_CSV_TEMPLATE = 'https://app.dev.kidvestors.co/assets/csv-templates/TeachersTemplate.csv';
export const LINK_ELEMENTARY_BACK_GROUND = 'https://app.dev.kidvestors.co/assets/certificates/ElementaryBg';
